import createErrors from '../createErrors';
import type { Page } from './constants';

export type Component = 'FavoriteList';

export const Errors = createErrors<Page, Component>('Favorites')({
    FavoriteList: {
        FetchInventoriesFailed: {
            severity: 'MEDIUM',
            message: 'Failed to fetch inventories',
        },
    },
});
